import { useTranslation } from '@mc/i18n'

import { Course } from 'types/data'

import { VideoButtons } from './components/VideoButtons'
import { VideoSection } from './components/VideoSection'
import { DescriptionSection } from './components/DescriptionSection'
import { AboutSectionVideoContextProvider } from './AboutSectionVideoContext'
import { VideoPlayer } from './components/VideoPlayer'
import { PageType } from './types'

interface SeriesAboutSectionProps {
  series: Course
  pageType: PageType
}

export const SeriesAboutSection = ({
  series,
  pageType,
}: SeriesAboutSectionProps) => {
  const { t } = useTranslation('@mc/next')

  const trailer = {
    brightcoveVideoId: series.brightcoveVideoId || '',
    mediaUuid: series.mediaUuid || '',
  }
  const sample = {
    brightcoveVideoId: series.sample?.brightcoveVideoId || '',
    mediaUuid: series.sample?.mediaUuid || '',
  }

  return (
    <AboutSectionVideoContextProvider
      pageType={pageType}
      series={series}
      trailer={trailer}
      sample={sample}
    >
      <section aria-labelledby='about-section'>
        <div className='row'>
          <h2 className='col-12 mc-text-h2 mc-text-md--left mc-text--center'>
            {t('series.details.title')}
          </h2>
          <div className='col-lg-8'>
            <VideoPlayer />
            <VideoSection series={series} />
          </div>

          <div className='d-flex flex-column align-items-stretch mc-text-small col-lg-4'>
            <VideoButtons series={series} trailer={trailer} sample={sample} />
            <DescriptionSection
              description={series.overview || ''}
              starring={series.instructorName || ''}
              length={series.numChapters || 0}
              categories={series.categoriesLabel || ''}
            />
          </div>
        </div>
      </section>
    </AboutSectionVideoContextProvider>
  )
}
